const info = {
    title: `Hormonal Contraception`,
    subtitle: `Let Us Help You`,
}

export default info

